import React, { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import Sidebar from "../../comps/Sidebar";
import Swal from "sweetalert2";
import {
  FaDollarSign,
  FaClock,
  FaCheckCircle,
  FaWallet,
  FaPlus,
} from "react-icons/fa";

const WithDraw = () => {
  const [showModal, setShowModal] = useState(false);
  const [withdrawals, setWithdrawals] = useState([
    {
      id: 1,
      amount: "USD 500",
      fundraiser: "You",
      status: "Accepted",
      method: "BANK",
      date: "July 18th 2022, 5:29 PM",
      attachment: "No attachment",
    },
  ]);

  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("");
  const [note, setNote] = useState("");

  const handleSendClick = () => {
    if (!amount || !method) {
      Swal.fire("Oops", "Please fill in all required fields", "error");
      return;
    }

    const newWithdrawal = {
      id: withdrawals.length + 1,
      amount: `USD ${amount}`,
      fundraiser: "You",
      status: "Requested",
      method: method.toUpperCase(),
      date: new Date().toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      }),
      attachment: "No attachment",
    };

    setWithdrawals([newWithdrawal, ...withdrawals]);
    setAmount("");
    setMethod("");
    setNote("");
    setShowModal(false);

    Swal.fire({
      title: "Success!",
      text: "Payment Request Created Successfully",
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  return (
    <>
      <Header />
      <div className="flex min-h-screen bg-[#0B0F1F] text-white">
        <Sidebar />

        <main className="flex-1 p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
            {[
              {
                icon: <FaDollarSign className="text-[#00AEEF] text-3xl" />,
                title: "Net Earnings",
                value: "USD 2,052.00",
                color: "text-[#00AEEF]",
              },
              {
                icon: <FaClock className="text-yellow-500 text-3xl" />,
                title: "Pending Clearance",
                value: "USD 0.00",
                color: "text-yellow-400",
              },
              {
                icon: <FaCheckCircle className="text-green-500 text-3xl" />,
                title: "Withdrawn",
                value: "USD 0.00",
                color: "text-green-400",
              },
              {
                icon: <FaWallet className="text-purple-500 text-3xl" />,
                title: "Available for Withdrawal",
                value: "USD 2,052.00",
                color: "text-purple-400",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-[#121829] rounded-xl p-5 shadow hover:shadow-lg transition flex flex-col items-center text-center"
              >
                {item.icon}
                <div className={`mt-3 text-xl font-semibold ${item.color}`}>
                  {item.value}
                </div>
                <div className="text-gray-400 text-sm mt-1">{item.title}</div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-white">Payout History</h2>
            <button
              onClick={() => setShowModal(true)}
              className="flex items-center gap-2 bg-[#00AEEF] text-white px-4 py-2 rounded-md hover:bg-[#0091c4] shadow-md transition"
            >
              <FaPlus className="text-sm" />
              New Withdrawal Request
            </button>
          </div>

          <div className="overflow-x-auto bg-[#121829] rounded-xl shadow-md">
            <table className="min-w-full divide-y divide-gray-700 text-sm">
              <thead className="bg-[#1A2238] text-white font-semibold">
                <tr>
                  <th className="px-6 py-3 text-left">Payout ID</th>
                  <th className="px-6 py-3 text-left">Amount</th>
                  <th className="px-6 py-3 text-left">Fundraiser</th>
                  <th className="px-6 py-3 text-left">Status</th>
                  <th className="px-6 py-3 text-left">Method</th>
                  <th className="px-6 py-3 text-left">Date</th>
                  <th className="px-6 py-3 text-left">Attachment</th>
                  <th className="px-6 py-3 text-left">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {withdrawals.map((w) => (
                  <tr key={w.id} className="hover:bg-[#1E2A47] transition text-white">
                    <td className="px-6 py-4">#{w.id}</td>
                    <td className="px-6 py-4">{w.amount}</td>
                    <td className="px-6 py-4">{w.fundraiser}</td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-block text-white text-xs font-medium px-2 py-1 rounded-full ${w.status === "Accepted"
                          ? "bg-green-700"
                          : w.status === "Requested"
                            ? "bg-yellow-600"
                            : "bg-gray-600"
                          }`}
                      >
                        {w.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">{w.method}</td>
                    <td className="px-6 py-4">{w.date}</td>
                    <td className="px-6 py-4 text-gray-400">{w.attachment}</td>
                    <td className="px-6 py-4">
                      <button className="text-[#00AEEF] hover:text-white transition">
                        ⚙
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="px-6 py-4 text-gray-400 text-sm">
              Showing {withdrawals.length} of {withdrawals.length}
            </div>
          </div>
        </main>
      </div>

      <Footer />

      {showModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center px-4">
          <div className="bg-[#121829] rounded-lg w-full max-w-md p-6 relative text-white">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-red-500 text-xl"
            >
              &times;
            </button>

            <h2 className="text-xl font-bold mb-4">New Withdrawal Request</h2>

            <div className="mb-4">
              <label className="block text-sm font-semibold mb-1">Amount</label>
              <div className="flex rounded-md shadow-sm">
                <span className="inline-flex items-center px-3 bg-[#1A2238] border border-gray-700 text-gray-300 text-sm">
                  $
                </span>
                <input
                  type="text"
                  placeholder="0.00"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="flex-1 bg-[#1A2238] border border-gray-700 rounded-r-md px-3 py-2 text-sm text-white focus:outline-none focus:ring focus:ring-[#00AEEF]"
                />
                <span className="inline-flex items-center px-3 bg-[#1A2238] border border-gray-700 text-gray-300 text-sm">
                  USD
                </span>
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-semibold mb-1">Payment Method</label>
              <select
                value={method}
                onChange={(e) => setMethod(e.target.value)}
                className="w-full bg-[#1A2238] border border-gray-700 rounded-md px-3 py-2 text-sm text-white focus:outline-none focus:ring focus:ring-[#00AEEF]"
              >
                <option value="">Select Payment Method</option>
                <option value="bank">Bank</option>
                <option value="paypal">PayPal</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-semibold mb-1">Note</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                rows="3"
                className="w-full bg-[#1A2238] border border-gray-700 rounded-md px-3 py-2 text-sm text-white focus:outline-none focus:ring focus:ring-[#00AEEF]"
                placeholder="Write note here..."
              ></textarea>
            </div>

            <button
              onClick={handleSendClick}
              className="w-full bg-[#00AEEF] text-white py-2 rounded-md hover:bg-[#0091c4] transition font-medium"
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default WithDraw;
